import { amountAsCurrency } from "currency";
import { View } from "react-native";
import { useTailwind } from "tailwind-rn";

import { WithdrawalDetails } from "../../types";
import CardText from "../CardText";
import TransactionCard from "../TransactionCard";

type Props = {
  breakdown: WithdrawalDetails["breakdown"];
};

export default function BreakdownCard({ breakdown }: Props) {
  const tailwind = useTailwind();

  return (
    <TransactionCard>
      <CardText.Title text="Desglose" />
      {breakdown.lines.map(({ text, amount, currency }, index) => (
        <View style={tailwind("flex-row justify-between mt-1")} key={index}>
          <CardText.Body text={text} />
          <CardText.Body text={amountAsCurrency({ amount, currency })} />
        </View>
      ))}
    </TransactionCard>
  );
}
